import { Pipe, PipeTransform } from '@angular/core';
import { TchekStatus } from '../model/tchekb.model';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Pipe({
  name: 'tchekStatus'
})
export class TchekStatusPipe implements PipeTransform {
  private labelsFr: Array<string>;

  constructor( private readonly i18n: I18n) {
    this.labelsFr = [];
    this.labelsFr[TchekStatus.LOADING] = this.i18n({ id: 'label_loading',
    value: "En chargement",
    description: "En chargement",
    meaning: "label"
  });
    this.labelsFr[TchekStatus.UNREAD] = this.i18n({ id: 'label_not_read',
    value: "Non lu",
    description: "Non lu",
    meaning: "label"
  });
    this.labelsFr[TchekStatus.READ] = this.i18n({ id: 'label_read',
    value: "Lu",
    description: "Lu",
    meaning: "label"
  });
    this.labelsFr[TchekStatus.LITIGATION] = this.i18n({ id: 'label_litigation',
    value: "En litige",
    description: "En litige",
    meaning: "label"
  });
    this.labelsFr[TchekStatus.CLOSED] = this.i18n({ id: 'label_closed',
    value: "Traité",
    description: "Traité",
    meaning: "label"
  });
  this.labelsFr[TchekStatus.INSPECTED] = this.i18n({ id: 'label_inspected',
  value: "Inspecté",
  description: "Inspecté",
  meaning: "label"
});
  }

  transform(value: TchekStatus, args?: any): any {
    if (Object.values(TchekStatus).includes(value))
      return this.labelsFr[value];
    else
      return '-';
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/tchek-status.pipe.ts